<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 搜索框 -->
		<div class="titleView">
			<div style="display: flex;align-items: center;">
				<el-input v-model="serchValue" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput" clearable size="small"/>
				<el-button type="button" style="margin-left: 10px;" @click="handelSearchClick" size="small">搜索</el-button>
			</div>
			<div class="flex">
				<div class="m-r-10">日期</div>
				<el-date-picker v-model="dateValue" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handelSearchClick" size="small" class="titleDate">
				</el-date-picker>
			</div>
			<div class="flex">
				<div class="m-r-10">活动状态</div>
				<el-select v-model="statusValue" placeholder="请选择" class="titleSelect" @change="handelSearchClick" size="small">
					<el-option v-for="item in statuss" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</div>
			<div style="flex: 1;display: flex;justify-content: flex-end;">
				<el-button type="warning" class="addClick" @click="handleResetClick" size="small">重置</el-button>
				<el-button class="addClick" @click="handleAddClick" size="small">新建商品配置</el-button>
			</div>
		</div>

		<!-- 表格 -->
		<div class="tableView">
			<el-table :data="tableData">
				<el-table-column prop="title" label="商品名称" :key="1" align="center">
				</el-table-column>
				<el-table-column prop="priority" label="优先级" :key="5" align="center">
				</el-table-column>
				<el-table-column prop="performanceNum" label="提成编号" :key="3" align="center">
				</el-table-column>
				<el-table-column  label="创建人" :key="4" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.createOperationInfo.userName }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="start_time" label="创建时间" :key="8" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.createOperationInfo.operationTime}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" :key="6" align="center">
				</el-table-column>
				<el-table-column label="操作" :key="7" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-if="scope.row.status != 2" @click="handelDeleteClick(scope.row)">删除</el-button>
						<el-button type="text" size="small" @click="handelEditClick(scope.row,1)">查看</el-button>
						<el-button type="text" size="small" v-if="scope.row.status != 2" @click="handelEditClick(scope.row,2)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
		</div>
	</div>
</template>

<script>
	import {
		getList,
		startActivit,
		stopActivit,
		getInfo,
		deleteActive
	} from "@/api/purchaseApi.js"
	import page from "../../components/page.vue"
	export default {
		components: {
			page
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				serchValue: '', //搜索
				fixedHeight: '',
				dateValue: [], //活动日期
				activity_model: -1, //线上线下值
				activity_models:[{  //线上线下列表
					label: '全部',
					value: -1,
				}, {
					label: '线上',
					value: 1
				}, {
					label: '线下',
					value: 2
				}],
				activity_type: -1, //活动类型值
				activity_types: [{ //活动类型列表
					label: '全部',
					value: -1
				}, {
					label: '充值',
					value: 1
				}, {
					label: '消费',
					value: 2
				}],
				statusValue: -1, //活动状态值
				statuss: [{ //活动状态列表
					label: '全部',
					value: -1
				}, {
					label: '未进行',
					value: 1
				}, {
					label: '进行中',
					value: 2
				}, {
					label: '已结束',
					value: 3
				}, {
					label: '已停用',
					value: 4
				}],
				tableData: [], //表格数据
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 106;
			this.getTableData()
		},
		methods: {
			//搜索
			handelSearchClick(){
				this.page.page = 1;
				this.getTableData()
			},
			//删除
			handelDeleteClick(row){
				this.$confirm('是否删除该配置？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id:row.id,
					}
					this.$http.get(process.env.VUE_APP_zichan + '/api/Performance/DeleteGoodsPerformance', params).then((res)=>{
						if(res.code == 0){
							console.log(res)
							this.$message({
								type: 'info',
								message: '已删除'
							})
							this.getTableData()
						}
					})
				})
			},
			//编辑与查看
			handelEditClick(row,type){
				console.log(row,type)
				let params = {
					id:row.id
				}
				this.$http.get(process.env.VUE_APP_zichan + '/api/Performance/GetGoodsPerformanceRecord', params)
					.then(res => {
					if(res.code == 0){
						console.log(res)
						let query = {
							type:type,
							activitInfo:JSON.stringify(res.data)
						}
						console.log(query)
						this.$router.push({path: 'addGoods',query})
					}
				})
			},
			//格式化日期
			timeFormat(time){
				let date = Number(time)*1000; 
				if (date === undefined) { 
					return ""; 
				} 
				let moment = require("moment");
				return moment(date).format("YYYY-MM-DD HH:mm:ss"); 
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//获取列表
			getTableData() {
				let pamars ={
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
					keyWord:'',
				}
				// console.log(pamars)
				this.$http.post(
            process.env.VUE_APP_zichan + "/api/Performance/GetGoodsPerformanceRecordList",
            pamars
          ).then((res)=>{
					console.log(res)
					if (res.code == 0) {
						this.tableData = res.data.list;
						this.page.total = res.data.count;
					}
				})
			},
			// 重置
			handleResetClick() {
				this.page.page = 1;
				this.serchValue = '';
				this.dateValue = [];
				this.activity_model = -1;
				this.activity_type = -1;
				this.statusValue = -1;
				this.getTableData()
			},
			// 新建活动
			handleAddClick() {
				this.$router.push({path: 'addGoods'})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.titleView {
		height: 72px;
		line-height: 72px;
		display: flex;
		background: #fff;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;
		font-size: 12px;
		padding: 0 10px;
		
		.titleInput {
			width: 130px;
		}

		.titleDate {
			width: 340px;
		}

		.titleSelect {
			width: 80px;
		}
	}
	
	.flex {
		display: flex;
		align-items: center;
		margin-left: 10px;
	}

	.m-r-10 {
		margin-right: 10px;
		font-size: 12px;
	}
	.tableView{
		padding-bottom: 10px;
		background: #fff;
	}
</style>
